import styled from 'react-emotion'
import { color, space4, space8 } from '../style'

const Text = styled('span')(
  ({
    small,
    normal,
    medium,
    bold,
    black,
    red,
    light,
    grey,
    truncate,
    multiline,
    onClick
  }) => ({
    label: 'Text',
    fontSize: small && 12,
    fontWeight: normal ? 400 : medium ? 500 : bold && 600,
    color:
      grey && light
        ? color.greyLight
        : black
        ? color.black
        : light
        ? color.blackLight
        : grey
        ? color.grey
        : red && color.red,

    cursor: onClick && 'pointer',
    '&:hover': onClick && {
      color: grey ? color.black : color.grey
    },

    // truncate
    // used in other elements: We need a child element to do
    // text-overflow: ellipsis beacuse it doesn't play nice with flex
    overflow: truncate && 'hidden',
    textOverflow: truncate && 'ellipsis',
    lineHeight: (truncate || multiline) && 1.25, // stop truncate:hidden from clipping descenders
    whiteSpace: truncate ? 'nowrap' : multiline && 'normal',

    // when directly inside a Row, not within a label or button more space is needed
    '.row > &:first-child': { marginLeft: 11 },
    '.row > &:last-child': { marginRight: 11 }
  })
)

export const Title = styled('h1')({
  fontSize: 28,
  lineHeight: 1.25,
  fontWeight: 600,
  textAlign: 'center',
  marginTop: 0,
  marginBottom: 0,
  marginLeft: space8,
  marginRight: space8
})

export const Paragraph = styled(Text)({
  display: 'block',
  lineHeight: 1.25,
  marginTop: space4,
  marginBottom: space4
})

export default Text
